import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {getToken} from './../actions/getTokenActions';
import {
  Box,
  Button,
  Container,
  Card,
  CardContent,
  TextField,
  Typography,
  Grid,
  Alert,
  AlertTitle
} from '@material-ui/core';
import { useEffect } from 'react';
import { getAuthUserDataThunk } from 'src/reducers/auth-reducer';
import { useState } from 'react';

const Login = () => {
  const navigate = useNavigate();
  const isLogin = useSelector(state => state.gettocken.islogin);
  const token = useSelector(state => state.gettocken.apitoken);
  const loginErr = useSelector(state => state.gettocken.error);
  const dispatch = useDispatch();
  const [isRequestError, setRequestError] = useState(false)
  const [isInputError, setInputError] = useState(false)

 

  useEffect(()=> {
    isLogin && navigate('/app/dashboard', { replace: true });
    isLogin && dispatch(getAuthUserDataThunk(token))
  }, [isLogin, token])

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Card>
            <CardContent>
          <Formik
            initialValues={{
              email: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email('Must be a valid email').max(255).required('Email is required') ,
              password: Yup.string().max(255).required('Password is required')
            })}
            onSubmit={async (values) => {
              var res = await dispatch(getToken({username: values.email, password: values.password}));
              if(res.payload.error.stack.toString().includes("handleErrors")) {
                setInputError(true)
                setRequestError(false)
              }
              if(res.payload.error.stack.toString().includes("Failed to fetch")) {
                setRequestError(true)
                setInputError(false)
              }
          console.log("RESPONSE DISPATCH: ", res)
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                  >
                    Anmelden
                  </Typography>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    Bitte melden Sie sich an!
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.email && errors.email) || loginErr !== null}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email Address"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                 // type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password) || loginErr !== null}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box sx={{ py: 2 }}>
                  <Button
                    color="primary"
                   // disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Anmelden
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
           </CardContent>
          </Card>

          {isRequestError && <Grid>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Es ist ein Server Fehler aufgetreten! Bitte versuchen Sie es noch mal.
        </Alert>
      </Grid>}
      {isInputError && <Grid>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Der Benutzername bzw. das Kennwort ist falsch.
        </Alert>
      </Grid>}
        </Container>
      </Box>
    </>
  );
};

export default Login;
